import { render, staticRenderFns } from "./DossierInformations.vue?vue&type=template&id=67467f98&"
import script from "./DossierInformations.vue?vue&type=script&lang=js&"
export * from "./DossierInformations.vue?vue&type=script&lang=js&"
import style0 from "./DossierInformations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports